module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suspiciousRulers"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    规则设置\n    "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("权重设置")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "rulesForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.rulesForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "违规分数线：",
      "prop": "score"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.rulesForm.score),
      callback: function($$v) {
        _vm.$set(_vm.rulesForm, "score", $$v)
      },
      expression: "rulesForm.score"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("\n        权重说明： 1个关注记" + _vm._s(_vm.formedit.score1) + "分，1个私信记" + _vm._s(_vm.formedit.score2) + "分\n      ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "权重设置",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('el-form', {
    ref: "formedit",
    attrs: {
      "model": _vm.formedit,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "1个关注分数：",
      "label-width": _vm.formLabelWidth,
      "prop": "score1"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.score1),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "score1", $$v)
      },
      expression: "formedit.score1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "1个私信分数：",
      "label-width": _vm.formLabelWidth,
      "prop": "score2"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.score2),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "score2", $$v)
      },
      expression: "formedit.score2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    规则说明：\n    "), _c('br'), _vm._v("1.违规线分数设置后，当用户每日总分>=违规线分数时，将会进入可疑用户列表\n    "), _c('br'), _vm._v("\n    2.权重设置分为两个维度即每日私信以及关注人数\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3282de44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/userM/suspiciousRulers.vue
// module id = 982
// module chunks = 0